import parseQueryString from "@insite/client-framework/Common/Utilities/parseQueryString";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getBillToState } from "@insite/client-framework/Store/Data/BillTos/BillTosSelectors";
import {
    getCartState,
    getCurrentCartState,
    hasProductsWithInvalidPrice,
} from "@insite/client-framework/Store/Data/Carts/CartsSelector";
import { getLocation } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import { getShipToState } from "@insite/client-framework/Store/Data/ShipTos/ShipTosSelectors";
import translate from "@insite/client-framework/Translate";
import Button, { ButtonPresentationProps } from "@insite/mobius/Button";
import { ErrorContext } from "@tKgpco/Overrides/Pages/CheckoutReviewAndSubmitPage";
import CustomApplicationState from "@tKgpco/Store/CustomApplicationState";
import React, { FC, useContext, useEffect, useState } from "react";
import { connect } from "react-redux";

interface OwnProps {
    styles?: ButtonPresentationProps;
}

const mapStateToProps = (state: CustomApplicationState) => {
    const { cartId, isPlacingOrder, isCheckingOutWithPayPay } = state.pages.checkoutReviewAndSubmit;
    const cartState = cartId ? getCartState(state, cartId) : getCurrentCartState(state);
    const billToState = getBillToState(state, cartState.value?.billToId);
    const shipToState = getShipToState(state, cartState.value?.shipToId);
    const cartStateCollect = getCurrentCartState(state).value;
    const { session } = state.context;
    const billTo = getBillToState(state, session.billToId).value;

    const { sessionId, redirectResult } = parseQueryString<{ sessionId?: string; redirectResult?: string }>(
        getLocation(state).search,
    );

    const checkoutReviewState = state.KGPState.CheckoutReview;

    return {
        isDisabled:
            cartState.isLoading ||
            billToState.isLoading ||
            !billToState.value ||
            shipToState.isLoading ||
            !shipToState.value ||
            !billToState.value.address1 ||
            !shipToState.value.address1 ||
            isPlacingOrder ||
            isCheckingOutWithPayPay ||
            (!!sessionId && !!redirectResult) ||
            hasProductsWithInvalidPrice(cartState.value) ||
            cartState.value?.hasInsufficientInventory === true ||
            !cartState.value?.canCheckOut ||
            !checkoutReviewState.expeditedUserName ||
            !checkoutReviewState.expeditedUserphone ||
            !checkoutReviewState.poNumber ||
            !checkoutReviewState.paymentMethod,
        isCheckoutDisabled: cartState.value?.canCheckOut === false,
        cartStatePrpoerties: cartStateCollect?.properties,
        deliveryTerms: billTo?.properties?.deliveryTerms || "",
        collectValue: state?.KGPState?.CheckoutReview.accountNumber || "",
        checkoutReviewState,
    };
};

type Props = OwnProps & ReturnType<typeof mapStateToProps>;

const CheckoutReviewAndSubmitPlaceOrderButton: FC<Props> = ({
    isDisabled,
    isCheckoutDisabled,
    styles,
    cartStatePrpoerties,
    deliveryTerms,
    collectValue,
}) => {
    const { state, updateError } = useContext(ErrorContext);

    const handleClick = () => {
        const deliveryTerm = deliveryTerms || "";
        const hasCollectAccount = cartStatePrpoerties?.hasOwnProperty("collectAccount");

        // condition: collect or Third Party.
        if (!collectValue && (deliveryTerm.toLowerCase() === "col" || deliveryTerm.toLowerCase() === "n")) {
            if (!hasCollectAccount) {
                updateError("collectAccountErrors", true);
                return;
            }
        }

        document.getElementById("reviewAndSubmitPaymentForm-submit")?.click();
    };

    return (
        <>
            {isCheckoutDisabled === true ? null : (
                <Button
                    type="submit"
                    disabled={isDisabled}
                    data-test-selector="checkoutReviewAndSubmit_placeOrder"
                    {...styles}
                    onClick={handleClick}
                >
                    {translate("Place Order")}
                </Button>
            )}
        </>
    );
};

export default connect(mapStateToProps)(CheckoutReviewAndSubmitPlaceOrderButton);
